/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeADownIcon20Solid = forwardRef('ArrowShapeADownIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.411 17.773a2.25 2.25 0 0 0 3.18 0l6.977-6.967c.851-.85.249-2.305-.954-2.305H14.75V4a2 2 0 0 0-2-2h-5.5a2 2 0 0 0-2 2v4.5H2.388c-1.203 0-1.805 1.455-.954 2.305l6.977 6.967Z" })));
});
